<template>

    <div class="container search-results-page">
        <form v-on:submit.prevent="handleForm" class="search container-fluid no-overlap" :data-context="resultsCards.dataContext">
            <label for="siteSearchResult" class="sr-only">Site Search</label>
            <input id="siteSearchResult" type="text" class="siteSearch resultSearch" :placeholder="resultsCards.searchbarPlaceholder" v-model="url.query">
            <button type="submit" class="searchSubmit" style="background-image: url(/dist/img/svg/icon-search-orange.svg);">
                <span class="sr-only">Submit Search</span>
            </button>
        </form>
        <div data-endpoint-id="SearchResultsData">
            <div class="columns row search-results">
                <div class="col-lg-3 offset-lg-9">
                    <div class="accordion-group">
                        <div class="accordion-container results-sort">
                            <button type="button" class="accordion-trigger preventScroll" aria-expanded="false" aria-controls="accordionResultSort" id="btnResultsSort" >
                                <h5 class="sort-title">
                                    sort by
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve" class="icon-arrow-right"><path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z"></path></svg>
                                </h5>
                            </button>
                            <div class="accordion" role="region" aria-labelledby="btnResultsSort" id="accordionResultSort">
                                <ul>
                                    <li class="preventScroll" v-bind:id="item.id" v-for="(item, index) in resultsCards.sort" v-on:click="updateSort(item.id)" tabindex="0" v-on:keyup="keymonitor">
                                        <div class="sort" v-bind:id="item.id" v-bind:class="{'selected': checkSort(item.id)}">
                                            {{item.displayName}}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sidebar col-lg-3">

                    <div class="results-filter-group">
                        <!--Currently each accordion within an accordion group will close automatically if another is clicked.
                    If this functionality is not needed a class of keep-open can be added to a accordion-container to prevent this-->
                        <div class="row accordion-group">
                            <div class="accordion-container results-filter col-lg-12 keep-open" v-for="item in resultsCards.filters" :key="item.id">
                                <button type="button" class="accordion-trigger preventScroll" aria-expanded="false" :aria-controls="formatToId('accordion', item.filterName)" :id="formatToId('btn', item.filterName)" @click="toggleAccordion($event)">
                                    <h5 class="filter-title">
                                        {{item.filterName}}
                                    </h5>
                                    <div class="icon">
                                        <i></i>
                                        <i></i>
                                    </div>
                                </button>
                                <div class="accordion" role="region" :aria-labelledby="formatToId('btn', item.filterName)" :id="formatToId('accordion', item.filterName)">
                                    <ul>
                                        <li :key="subitem.id" v-for="subitem in item.subfilters">
                                            <label :for="subitem.id">
                                                <input v-bind:id="subitem.id" v-bind:ref="subitem.displayName" :checked="checkFilters(subitem.id)" type="checkbox" v-on:click="toggleFilters(item.filterName, subitem.id)" />
                                                <span class="filter">
                                                    <span>
                                                        {{subitem.displayName}}
                                                    </span>
                                                </span>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="filter-buttons">
                            <button type="button" class="apply-filter" v-on:click="applyFilters">
                                apply <span class="sr-only">filters</span>
                            </button>
                            <button type="button" class="clear-filter" v-on:click="clearFilters">
                                clear all <span class="sr-only">filters</span>
                            </button>
                        </div>
                    </div>

                </div>

                <div class="main col-lg-9">

                    <ul class="sorted-results">
                        <span class="no-results">
                            {{resultsCards.noresults}}
                        </span>
                        <li class="results-card" :key="resultsCard.Id" v-for="resultsCard in resultsCards.total">
                            <div class="details">
                                <div class="tags has-ribbon" v-if="resultsCard.PrimaryTag">
                                    <div class="ribbon" v-if="resultsCard.PrimaryTagRGB" :style="'background-color: ' + resultsCard.PrimaryTagRGB + ';'"></div>
                                    <a href="#" :key="resultsCard.PrimaryTag[0]">
                                        <span>{{ resultsCard.PrimaryTagText }}</span>
                                    </a>
                                </div>

                                <div class="date">{{resultsCard.SearchDisplayDate}}</div>

                                <h3 class="result-title">{{ resultsCard.TeaserTitle }}</h3>

                                <div class="description">{{ resultsCard.TeaserSummary }}</div>
                                <a class="cta-primary" :href="resultsCard.TargetUrl" v-if="resultsCard.TargetUrl">
                                    {{resultsCard.TargetUrlText}}
                                    <svg version="1.1" class="icon-arrow-right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve">
                                    <path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z" />



		                        </svg>
                                </a>
                            </div>
                        </li>
                    </ul>
                    <div class="pagination" v-bind:class="{'hidden': url.pageCount <= 1}">
                        <button type="button" class="pagination-nav prev-page" v-on:click="prevPage" :disabled="url.pageNumber === 1"><span class="sr-only">Previous Page</span></button>
                        <span v-if="url.pageCount <= 5">
                            <button type="button" class="pagination-num" v-for="item in url.pageCount" v-on:click="getPage(item)" :key="item" :class="{ 'active': url.pageNumber == item}">
                                <span class="sr-only">Page </span>{{ item }}<span class="sr-only"> of {{ url.pageCount }}</span>
                            </button>
                        </span>
                        <span v-else-if="url.pageCount > 5">
                            <button type="button" v-if="item == 1 || item == url.pageCount || item == url.pageNumber - 1 || item == url.pageNumber - 2 || item == url.pageNumber + 1 || item == url.pageNumber + 2 || item == url.pageNumber" class="pagination-num" v-for="item in url.pageCount" v-on:click="getPage(item)" :key="item" :class="{ 'active': url.pageNumber == item, 'trunc-start': item == 1 && url.pageNumber > 4, 'trunc-end': item == url.pageCount && url.pageNumber < url.pageCount - 3}">
                                <span class="sr-only">Page </span>{{ item }}<span class="sr-only"> of {{ url.pageCount }}</span>
                            </button>
                        </span>
                        <button type="button" class="pagination-nav next-page" v-on:click="nextPage" :disabled="url.pageNumber === url.pageCount"><span class="sr-only">Next Page</span></button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'Search Results Page',
        el: '.search-results-page',
        data() {
            return {
                resultsCards: {
                    //set url to window.location.href on page load
                    urlwithquery: "https://www.fultoncounty.gov/?query=commissioners&filters=000-0000-100-0001%7C000-0000-100-0004&sortby=az&pageCount=2&pageNumber=1",
                    urlnoquery: "https://www.fultoncounty.gov/?query=&filters=&sortby=",
                    urlraw: "https://www.fultoncounty.gov/search",
                    url: window.location.href,
                    sort: [],
                    total: [],
                    filters: [],
                    searchbarPlaceholder: "",
                    noresults:""

                },
                url: {
                    filters: [],
                    query: [],
                    sortBy: {},
                    pageNumber: {},
                    pageCount: {},
                    startingPath: ""
                }
            }
        },

        mounted: function () {
            /* eslint-disable no-console */
            var self = this;
            self.decodeUrl();//update the url in address bar regardless of how they got here
            self.setup();
        },
        methods: {
            setup: function () {
                var self = this;
                var dataContext = window.context;
                var endpoint = window.location.origin + "/api/feature/search/pagesetup?datasource=" + dataContext;
                var request = new XMLHttpRequest();
                request.open('POST', endpoint, true);
                request.onload = function () {
                    if (request.status >= 200 && request.status < 400) {// Success!
                        var response = JSON.parse(request.responseText);
                        self.resultsCards.filters = response.data.filters;
                        self.resultsCards.sort = response.data.sort;
                        self.url.sortBy = response.data.sort[0].id;
                        self.resultsCards.searchbarPlaceholder = window.searchbarPlaceholder;
                        self.resultsCards.noresults = window.noResults;
                        if (response.data.StartingPath) {
                        self.url.startingPath = response.data.StartingPath;
                        }
                        self.updateQuery();
                    } else {
                        // We reached our target server, but it returned an error
                        console.log("error");
                    }
                };

                request.onerror = function () {
                    // There was a connection error of some sort
                    console.log("connection error");
                };
                request.send();
            },
            nextPage: function () {
                var self = this;
                self.url.pageNumber++;
                self.constructUrl();
                self.updateQuery();
            },
            prevPage: function () {
                var self = this;
                self.url.pageNumber--;
                self.constructUrl();
                self.updateQuery();
            },
            getPage: function (num) {
                var self = this;
                self.url.pageNumber = num;
                self.constructUrl();
                self.updateQuery();
            },
            updateSort: function (el) {
                var self = this;
                self.url.sortBy = [el]; //update data to hold id of new sort method
                self.constructUrl(); //build the url and update the browser
                self.closeSort();
                self.updateQuery(); //make the call
            },
            applyFilters: function () {
                var self = this;
                self.url.pageNumber = 1;
                self.constructUrl();
                self.updateQuery();
            },
            toggleFilters: function (category, subcat) {
                var self = this;
                if (!self.url.filters.includes(subcat)) { //if the filter doesn't exist in data
                    self.url.filters.push(subcat); //add it
                }
                else {
                    self.url.filters = self.url.filters.filter(function (el) {
                        return el != subcat; //otherwise update the filter data without the unchecked filter
                    });
                }
            },
            clearFilters: function () {
                var self = this;
                self.url.filters = [];
                self.url.query = [];
                let searchBars = document.querySelectorAll('.siteSearch ');
                searchBars.forEach(function (bar) {
                    bar.value = "";
                })
                self.applyFilters();
            },
            closeSort: function () {
                var sorter = document.querySelectorAll(".results-sort");
                var active = sorter[0].querySelectorAll(".active");
                active.forEach(function (item) {
                    item.classList.remove("active");
                    if (item.classList.contains("accordion")) {
                        item.style.height = "0px";
                    }
                });
            },
            decodeUrl: function (url) {
                var self = this;
                url = self.resultsCards.url;
                if (!url) url = location.href;
                var question = url.indexOf("?");
                var hash = url.indexOf("#");
                if (hash == -1 && question == -1) {//missing query params
                    self.url.filters = [];
                    self.url.query = "";
                    self.url.sortBy = "relevance";
                    self.url.pageCount = "";
                    self.url.pageNumber = 1;
                    self.constructUrl();
                    return;
                };
                if (hash == -1) hash = url.length;
                var query = question == -1 || hash == question + 1 ? url.substring(hash) :
                    url.substring(question + 1, hash);
                var result = {};
                query.split("&").forEach(function (part) {
                    if (!part) return;
                    part = part.split("+").join(" "); // replace every + with space, regexp-free version
                    var eq = part.indexOf("=");
                    var key = eq > -1 ? part.substr(0, eq) : part;
                    var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : "";
                    val = val.split("|");
                    var from = key.indexOf("[");
                    if (from == -1) result[decodeURIComponent(key)] = val;
                    else {
                        var to = key.indexOf("]", from);
                        var index = decodeURIComponent(key.substring(from + 1, to));
                        key = decodeURIComponent(key.substring(0, from));
                        if (!result[key]) result[key] = [];
                        if (!index && !val) result[key].push(val);
                        else result[key][index] = val;
                    }
                });
                if (!result.filters || result.filters.length <= 0) {
                    self.url.filters = [];
                }
                else {
                    self.url.filters = result.filters;
                }
                if (!result.query || result.query.length <= 0) {
                    self.url.query = "";
                }
                else {
                    self.url.query = result.query;
                }
                if (!result.sortBy || result.sortBy.length <= 0 || self.resultsCards.sort.indexOf(result.sortBy[0] = -1)) {
                    self.url.sortBy = "relevance";
                }
                else {
                    self.url.sortBy = result.sortBy;
                }
                if (!result.pageCount || result.pageCount <= 0) {
                    self.url.pageCount = "";
                }
                else {
                    self.url.pageCount = result.pageCount
                }
                if (!result.pageNumber || result.pageNumber <= 0) {
                    self.url.pageNumber = 1;
                }
                else {
                    self.url.pageNumber = result.pageNumber;
                }
                self.constructUrl();
            },
            constructUrl: function () {
                var self = this;
                var domain = window.location.pathname;
                var getFilters = function () {
                    return (self.url.filters.length > 0 ? self.url.filters.join('%7C') : "")
                };
                var getQuery = function () {
                    return (self.url.query ? self.url.query : "")
                };
                var getSortBy = function () {
                    return (self.url.sortBy ? self.url.sortBy : "relevance")
                };
                var getPageCount = function () {
                    return (self.url.pageCount ? self.url.pageCount : "")
                };
                var getPageNumber = function () {
                    return (self.url.pageNumber ? self.url.pageNumber : 1)
                };
                var filters = getFilters();
                var query = getQuery();
                var sortBy = getSortBy();
                var pageCount = getPageCount();
                var pageNumber = getPageNumber();
                var fullUrl = domain + "?query=" + query + "&filters=" + filters + "&sortBy=" + sortBy + "&pageNumber=" + pageNumber;
                self.updateBrowserUrl(fullUrl);
            },
            checkFilters: function (n) {
                var self = this;
                return self.url.filters.indexOf(n) > -1
            },
            checkSort: function (n) {
                var self = this;
                return self.url.sortBy.indexOf(n) > -1
            },
            updateBrowserUrl: function (newUrl) {
                window.history.pushState({}, "title", newUrl);
            },
            updateQuery: function () {
                var self = this;
                var url = window.location.href;
                var question = url.indexOf("?");
                var query = url.substring(question, url.end);
                var starting = "&startingPath=" + encodeURIComponent(self.url.startingPath);
                var endpoint = window.location.origin + "/api/feature/search" + query + starting;
                var request = new XMLHttpRequest();
                request.open('POST', endpoint, true);
                request.onload = function () {
                    if (request.status >= 200 && request.status < 400) {
                        // Success!
                        var response = JSON.parse(request.responseText);
                        self.resultsCards.total = response.Results;
                        self.url.sortBy = response.SortBy;
                        self.url.pageNumber = response.PageNumber;
                        self.url.pageCount = response.TotalPages;
                        self.resultsCheck();
                    } else {
                        // We reached our target server, but it returned an error
                        console.log("error");
                    }
                };
                request.onerror = function () {
                    // There was a connection error of some sort
                    console.log("connection error");
                };

                request.send();
            },
            handleForm: function () {
                var self = this;
                var searchBar = document.querySelectorAll(".resultSearch");
                self.url.query = searchBar[0].value;
                self.url.pageNumber = 1;
                self.constructUrl();
                self.updateQuery();

            },
            toggleAccordion: function (event) {
                //disable accordion in footer on desktop
                const trigger = event.currentTarget;
                const panel = trigger.nextElementSibling;
                
                if (trigger.classList.contains('active')) {
                    // Closing
                    trigger.classList.remove("active");
                    trigger.setAttribute('aria-expanded', false);
                    panel.style.height = "0px";
                    panel.classList.remove("active");
                    // Set display to none after transition
                    setTimeout(() => {
                        if (!trigger.classList.contains('active')) {
                            panel.style.display = 'none';
                        }
                    }, 300); // Adjust timing as needed
                }
                else {
                    // Opening
                    panel.style.display = 'block';
                    trigger.classList.add("active");
                    trigger.setAttribute('aria-expanded', true);
                    let ht = panel.scrollHeight;
                    panel.style.height = `${ht}px`;
                    panel.classList.add("active");
                }
                
            },
            formatToId(prefix, name) {
                if (!name) return '';
                return prefix + name.trim().replace(/\s+/g, '');
            },
            keymonitor: function (event) {
                var self = this;
                if (event.key == " ") {
                    self.updateSort(event.currentTarget.id)
                }
            },
            resultsCheck: function () {
                var self = this;
                let warning = document.querySelectorAll(".no-results");
                if (self.resultsCards.total.length === 0) {
                    warning[0].classList.add("active");
                }
                else {
                    warning[0].classList.remove("active");
                }
            },
        }
    };
</script>